export default defineNuxtRouteMiddleware(() => {
  const { navigationPurge } = useModals()
  navigationPurge()
})
